/*@ngInject*/
module.exports = function (publicObjectsService, classifiersService, $rootScope, $uibModalInstance) {
    const vm = this;
    vm.suggestionForm = {};
    vm.suggestion = {};
    vm.showErrors = false;
    vm.saved = false;
    vm.rootScope = $rootScope;
    vm.modalInstance = $uibModalInstance;

    vm.clearData = () => {
        vm.suggestion = {};
        vm.showErrors = false;
    };

    vm.close = () => vm.modalInstance.close();

    vm.$onInit = () => {
        classifiersService.getSuggestionClassifiers().then((result) => vm.suggestionClassifiers = result.data);
    };

    vm.submitSuggestion = () => {
        vm.showErrors = true;
        if(vm.suggestionForm.$invalid) {
            return false;
        }
        publicObjectsService.addSuggestion(vm.suggestion).then((result) => {
            vm.saved = true;
            vm.saveSuccessful = result.data === 'ok';
            vm.rootScope.showSuccessModal = true;
            vm.rootScope.successMessage = 'suggestion_saved_successfully';
            vm.clearData();
            vm.close();
        });
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/suggestions/general-suggestion-modal.directive.js
 **/